import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  REGISTER_USER_CONFIRMATION,
  GET_PROVIDERS,
  REGISTER_PROVIDERS,
  GET_TERMS,
  REGISTER_TERMS,
  RESET_VALUES
} from "./actionTypes"

const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  providers: [],
  loadingSelect: false,
  termsConditions: null
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      state = {
        ...state,
        loading: true,
        registrationError: null,
      }
      break
    case REGISTER_USER_CONFIRMATION:
      state = {
        ...state,
        loading: true,
        registrationError: null,
      }
      break
    case GET_PROVIDERS:
      state = {
        ...state,
        loadingSelect: true
      }
      break
    case GET_TERMS:
      state = {
        ...state,
      }
      break
    case REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        registrationError: null,
      }
      break
    case REGISTER_USER_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
      }
      break
    case REGISTER_PROVIDERS:
      state = {
        ...state,
        providers: action.payload,
        loadingSelect: false
      }
      break
    case REGISTER_TERMS:
      state = {
        ...state,
        termsConditions: action.payload,
      }
      break
    case RESET_VALUES:
      state = {
        ...initialState,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
